import { FC } from 'react';
// @ts-ignore: federated module
import ViewResolverSection from 'ldpViewResolverSdm/Section';
// @ts-ignore: federated module
import { ListingPageComponent } from 'ldpViewResolverSdm/ListingPageComponent';

import { VIEW_RESOLVER } from '@/data/constants';
import { IPageLayout } from './page-layout.interface';

const PageLayout: FC<IPageLayout> = ({ typeId }) => {
  const { API_VERSION_V2: apiVersion, MAIN_CONTENT_COLLECTION, PAGE_LAYOUT_SINGLE_COLUMN } = VIEW_RESOLVER;

  const isClpPage = typeId === PAGE_LAYOUT_SINGLE_COLUMN;

  return (
    <>
      {isClpPage ? (
        <ViewResolverSection apiVersion={apiVersion} layoutSection={MAIN_CONTENT_COLLECTION} />
      ) : (
        <ListingPageComponent />
      )}
    </>
  );
};

export default PageLayout;
